// it needs for checking email. It is business email or not.
// TODO: move to backend
export const LIST_FREE_DOMAINS = [
  '123.com',
  '126.com',
  '139.com',
  '163.com',
  '20mail.it',
  '21cn.com',
  '3g.ua',
  'aapt.net.au',
  'about.com',
  'accountant.com',
  'adam.com.au',
  'address.com',
  'adexec.com',
  'aeiou.pt',
  'africamail.com',
  'aim.com',
  'airpost.net',
  'alice.it',
  'aliyun.com',
  'ameritech.net',
  'ancestry.com',
  'aol.com',
  'aon.at',
  'arcor.de',
  'att.net',
  'attglobal.net',
  'austin.rr.com',
  'aver.com',
  'bell.net',
  'bellsouth.net',
  'bigblue.net.au',
  'bigmir.net',
  'bigpond.com',
  'bigpond.com.au',
  'bigpond.net.au',
  'bk.ru',
  'bluemail.ch',
  'bluewin.ch',
  'blueyonder.co.uk',
  'bol.com.br',
  'bolt.com',
  'bresnan.net',
  'btconnect.com',
  'btinternet.com',
  'byom.de',
  'cable.comcast.com',
  'cableone.net',
  'caramail.com',
  'casema.nl',
  'cd2.com',
  'centrum.cz',
  'centrum.sk',
  'centurytel.net',
  'cfl.rr.com',
  'chacuo.net',
  'charter.net',
  'cheerful.com',
  'chef.net',
  'chello.nl',
  'collector.org',
  'colleges.com',
  'columbus.rr.com',
  'comcast.net',
  'comporium.net',
  'consultant.com',
  'contractor.net',
  'coolsite.net',
  'cox.net',
  'cs.com',
  'cutey.com',
  'cyberservices.com',
  'disposable.com',
  'doctor.com',
  'dodo.com.au',
  'dr.com',
  'dropmail.me',
  'earthlink.net',
  'ec.rr.com',
  'einrot.com',
  'eircom.net',
  'elitemail.org',
  'email.com',
  'email.cz',
  'email.it',
  'embarqmail.com',
  'eml.cc',
  'engineer.com',
  'europe.com',
  'excite.com',
  'execs.com',
  'exemail.com.au',
  'existiert.net',
  'eyepaste.com',
  'facebook.com',
  'fastmail.com',
  'fastmail.fm',
  'financier.com',
  'foxmail.com',
  'free.fr',
  'freemail.hu',
  'freenet.de',
  'frontier.com',
  'frontiernet.net',
  'ftc-i.net',
  'fuse.net',
  'gci.net',
  'get.pp.ua',
  'gmail.com',
  'gmx.at',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'gol.com',
  'googlemail.com',
  'graphic-designer.com',
  'groupmail.com',
  'guy.com',
  'hanmail.net',
  'hawaii.rr.com',
  'hawaiiantel.net',
  'hetnet.nl',
  'hitmail.com',
  'home.nl',
  'hot.ee',
  'hotmail.ca',
  'hotmail.ch',
  'hotmail.co.nz',
  'hotmail.co.uk',
  'hotmail.co.za',
  'hotmail.com',
  'hotmail.com.au',
  'hotmail.com.br',
  'hotmail.de',
  'hotmail.es',
  'hotmail.fi',
  'hotmail.fr',
  'hotmail.it',
  'hotmail.nl',
  'hot-shot.com',
  'hughes.net',
  'hushmail.com',
  'i.ua',
  'icloud.com',
  'ig.com.br',
  'iinet.net.au',
  'imap.cc',
  'iname.com',
  'inbox.com',
  'inbox.ru',
  'indeedemail.com',
  'india.com',
  'innocent.com',
  'inorbit.com',
  'interia.pl',
  'internode.on.net',
  'inwind.it',
  'iprimus.com.au',
  'ivillage.com',
  'jourrapide.com',
  'juno.com',
  'kpnmail.nl',
  'laposte.net',
  'lastmail.co',
  'lawyer.com',
  'libero.it',
  'linuxmail.org',
  'list.ru',
  'live.at',
  'live.be',
  'live.ca',
  'live.cn',
  'live.co.uk',
  'live.co.za',
  'live.com',
  'live.com.au',
  'live.com.mx',
  'live.com.pt',
  'live.com.sg',
  'live.de',
  'live.dk',
  'live.fr',
  'live.ie',
  'live.in',
  'live.it',
  'live.jp',
  'live.nl',
  'live.no',
  'live.ru',
  'live.se',
  'luukku.com',
  'mac.com',
  'mail.bg',
  'mail.com',
  'mail.de',
  'mail.ru',
  'mailbox.co.za',
  'mailbox.hu',
  'maildrop.cc',
  'maildx.com',
  'mailforce.net',
  'mailhaven.com',
  'mailismagic.com',
  'mail-tester.com',
  'mailtothis.com',
  'mchsi.com',
  'me.com',
  'meloo.com',
  'mindspring.com',
  'msgbox.com',
  'msn.com',
  'mt2015.com',
  'my.com',
  'myself.com',
  'myway.com',
  'name.com',
  'naver.com',
  'nc.rr.com',
  'netc.fr',
  'netscape.net',
  'netspace.net.au',
  'netzero.com',
  'netzero.net',
  'ntlworld.com',
  'nus.edu.sg',
  'nwytg.net',
  'onet.pl',
  'online.nl',
  'op.pl',
  'opayq.com',
  'opoczta.pl',
  'optonline.net',
  'optusnet.com.au',
  'orange.fr',
  'outlook.be',
  'outlook.co.nz',
  'outlook.com',
  'outlook.com.au',
  'outlook.com.gr',
  'outlook.de',
  'outlook.dk',
  'outlook.es',
  'outlook.fr',
  'outlook.ie',
  'outlook.in',
  'outlook.it',
  'outlook.kr',
  'outlook.ph',
  'outlook.pt',
  'outlook.sa',
  'outlook.sg',
  'ozemail.com.au',
  'pacbell.net',
  'peoplepc.com',
  'petlover.com',
  'pisem.net',
  'planet.nl',
  'planetmail.com',
  'playstation.sony.com',
  'poczta.fm',
  'pokemail.net',
  'post.com',
  'post.cz',
  'prodigy.net',
  'programmer.net',
  'protonmail.com',
  'q.com',
  'qq.com',
  'qualityservice.com',
  'quicknet.nl',
  'qwestoffice.net',
  'radiologist.net',
  'rambler.ru',
  'rcn.com',
  'reallymymail.com',
  'rediff.com',
  'rediffmail.com',
  'representative.com',
  'roadrunner.com',
  'rocketmail.com',
  'rogers.com',
  'runbox.com',
  'safe-mail.net',
  'safrica.com',
  'sanfranmail.com',
  'sapo.pt',
  'saudia.com',
  'sbcglobal.net',
  'scottsboro.org',
  'seznam.cz',
  'shaw.ca',
  'sina.cn',
  'sina.com',
  'singnet.com.sg',
  'sky.com',
  'skynet.be',
  'sms.at',
  'snet.net',
  'sohu.com',
  'solcon.nl',
  'solution4u.com',
  'ssl-mail.com',
  'sudomail.com',
  'swbell.net',
  'tafmail.com',
  'talk21.com',
  'tampabay.rr.com',
  'tds.net',
  'techemail.com',
  'techie.com',
  'technologist.com',
  'tele2.nl',
  'telefonica.net',
  'telenet.be',
  'telfort.nl',
  'temp.headstrong.de',
  'terra.com',
  'terra.com.br',
  'test.com',
  'therapist.net',
  'tiscali.co.uk',
  'tiscali.it',
  'toke.com',
  'tom.com',
  't-online.de',
  'tpg.com.au',
  'tut.by',
  'twc.com',
  'tx.rr.com',
  'uk2.net',
  'ukr.net',
  'ultra.fyi',
  'uol.com.br',
  'upcmail.nl',
  'urhen.com',
  'usa.com',
  'usa.net',
  'verizon.net',
  'veryrealemail.com',
  'vfemail.net',
  'videotron.ca',
  'vip.qq.com',
  'virgilio.it',
  'virginbroadband.com.au',
  'virginmedia.com',
  'vomoto.com',
  'vp.pl',
  'wanadoo.fr',
  'web.de',
  'webmail.co.za',
  'westnet.com.au',
  'whale-mail.com',
  'wideopenwest.com',
  'windowslive.com',
  'windstream.net',
  'woh.rr.com',
  'workmail.com',
  'wowway.com',
  'wp.pl',
  'writeme.com',
  'www.com',
  'xs4all.nl',
  'xtra.co.nz',
  'y7mail.com',
  'ya.ru',
  'yaho.com',
  'yahoo.ca',
  'yahoo.co',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.co.jp',
  'yahoo.co.nz',
  'yahoo.co.uk',
  'yahoo.co.za',
  'yahoo.com',
  'yahoo.com.ar',
  'yahoo.com.au',
  'yahoo.com.br',
  'yahoo.com.cn',
  'yahoo.com.hk',
  'yahoo.com.mx',
  'yahoo.com.my',
  'yahoo.com.ph',
  'yahoo.com.sg',
  'yahoo.com.tw',
  'yahoo.com.vn',
  'yahoo.de',
  'yahoo.dk',
  'yahoo.es',
  'yahoo.fr',
  'yahoo.gr',
  'yahoo.ie',
  'yahoo.in',
  'yahoo.it',
  'yahoo.no',
  'yahoo.ro',
  'yahoo.se',
  'yandex.com',
  'yandex.ru',
  'yandex.ua',
  'yeah.net',
  'ymail.com',
  'yopmail.com',
  'yours.com',
  'ziggo.nl',
  'zoho.com',
  'zonnet.nl',
  'zoominternet.net',
];
